import LocationNavigation from './LocationNavigation.vue';

export default {
    data() {
        return {
            open: false,
            region: false
        }
    },

    methods: {
        toggle(region) {
            this.open = !this.open;
            this.region = region;
            EventBus.$emit('ToggleModal');
        },
    },

    computed: {
        flagClass() {
            return `flag--${this.location.country}`;
        }
    },

    components: {
        LocationNavigation
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/CityModal.js